import { Suspense } from 'react'
import LoadingPage from 'src/components/LoadingPage'
import { UIDialog } from 'src/components/ui/Modal'
import type { GenerationModelDetailFragment } from 'src/services/apollo/generated/graphql'
import ModelDetail, { ModelDetailByModelId } from './ModelDetail'

export type SheetModelDetailOptions = {
  /** Seed fragment for optimistic rendering; refetched by id. */
  model?: GenerationModelDetailFragment
  /** Used when no `model` seed available. */
  modelId?: string
  /** Pin to a specific version. */
  versionId?: string
  /** Render sticky "Use this model" footer button on mobile. */
  onUse?: () => void
}

/** Mobile bottom-drawer / desktop dialog for model detail. */
export const sheetModelDetail = (opts: SheetModelDetailOptions = {}) => {
  if (!opts.model && !opts.modelId) return
  const { model, modelId, versionId, onUse } = opts
  return UIDialog.create({
    dismissable: true,
    responsive: true,
    children: ({ close }) => (
      <Suspense fallback={<LoadingPage fullHeight />}>
        {model ? (
          <ModelDetail
            model={model}
            versionId={versionId}
            onUse={onUse}
            onClose={close}
          />
        ) : modelId ? (
          <ModelDetailByModelId
            modelId={modelId}
            versionId={versionId}
            onUse={onUse}
            onClose={close}
          />
        ) : null}
      </Suspense>
    ),
    className: 'max-w-screen-mlg',
  })
}
